import EditorFacade from '../../../facade/editor/editor';
import DesignFacade from '../../../facade/design/design';
import RestrictionsFactory from '../../../factory/restrictions';
import ScrollableMixin from '../components/mixins/scrollable';

module.exports = Backbone.mixin(Backbone.View.extend({
  template: require('./template.hbs'),
  permissions: require('./permissions.json'),
  events: {
    'mouseup [data-key=restriction-switch]': 'toggleRestrictionEvent'
  },
  icons: {
    style: {
      image: 'image-style',
      text: 'text---nunito',
      element: 'paint-bucket'
    },
    content: {
      image: 'image---content',
      text: 'text-content',
      element: 'star'
    }
  },

  initialize: function () {
    EditorFacade.on('select', (selected) => this.show(selected));
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
    document.querySelector('[href="#tabSimplifiedRestrictions"]').parentNode.style.display = '';
    document.querySelector('[href="#tabRestrictions"]').parentNode.remove();
  },

  render: function (selectedElementId) {
    this.getRestrictedItems(selectedElementId).then((restrictedItems) => {
      const tr = INKIVE.TranslateHelper.translate;
      const type = ['image', 'text'].includes(this.selected?.type) ? this.selected.type : 'element';

      this.el.innerHTML = this.template({
        selected: this.selected,
        styleLabel: tr(`tool.restrictions.simplified_restrictions.styling.label.${type}`),
        styleIcon: this.icons.style[type],
        contentLabel: tr(`tool.restrictions.simplified_restrictions.content.label.${type}`),
        contentIcon: this.icons.content[type],
        restrictedItems: this.restrictedItems.filter((item) => {
          return item.id !== this.selected?.id && item.page === INKIVE.Tool._current_page_number;
        })
      });

      this.initListeners();
      this.initScroll();
    });
  },

  show: function (selected) {
    selected = selected || this.canvas.getSelectedElems();
    this.render(selected.length === 1 && selected[0].id);
  },

  initListeners () {
    this.el.querySelectorAll('.other-restricted-item .section-title').forEach((title) => {
      const element = document.getElementById(title.dataset.id);

      title.addEventListener('mouseenter', () => this.toggleOtherRestricted(title, element));
      title.addEventListener('mouseleave', () => this.toggleOtherRestricted(title, element));
      title.addEventListener('click', () => {
        if (element) {
          element.style.outline = '';
          this.canvas.selectOnly([element]);
          this.show({ element });
        }
      });
    });
  },

  toggleRestrictionEvent (event) {
    const restricted = event.currentTarget.classList.toggle('inactive');
    const data = event.currentTarget.dataset;
    const element = this.restrictedItems.find(item => item.id === data.element) || this.getElement(data.element);
    const finalRestrictions = {
      ...element.restrictions,
      ...this.getPermissionsSet(data.type, element.type, restricted)
    };

    this.disableSwitches(true);

    RestrictionsFactory.setGlobalElementRestriction(element.id,
      Object.keys(finalRestrictions).every((key) => finalRestrictions[key])
        ? null
        : JSON.stringify({ basic: finalRestrictions })
    ).then(() => {
      this.disableSwitches(false);
      this.getRestrictedItems();
    });

    const selected = this.canvas.getSelectedElems();

    if (selected.length === 1) {
      const selector = svgedit.select.getSelectorManager().requestSelector(document.getElementById(selected[0].id));
      selector.showGrips(true);
      selector.resize();
    }
  },

  disableSwitches (disabled) {
    this.el.querySelectorAll('.restriction-switch-container').forEach((node) => {
      node.classList.toggle('disabled', disabled);
    });
  },

  getPermissionsSet (dataType, elementType, restricted) {
    const permissions = {};

    this.permissions[dataType][elementType].forEach(item => {
      permissions[item] = !restricted;
    });

    return permissions;
  },

  getRestrictedItems (selectedId) {
    return new Promise(resolve => RestrictionsFactory.getElementPermissions().then((permissions) => {
      this.selected = null;
      this.restrictedItems = permissions.filter((i) => {
        return i.element_id !== 'background' &&
          (DesignFacade.get(i.element_id) && i.page_number === INKIVE.Tool._current_page_number);
      }).map((item) => {
        const element = this.getElement(item.element_id);
        const style = this.isDataSetRestricted('style', element.type, item.restrictions);
        const content = this.isDataSetRestricted('content', element.type, item.restrictions);

        return {
          ...element,
          page: item.page_number,
          style,
          content,
          restrictions: JSON.parse(item.restrictions).basic
        };
      });

      if (selectedId) {
        this.selected = this.restrictedItems.find((item) => item.id === selectedId);
        if (!this.selected && selectedId !== 'background') {
          this.selected = this.getElement(selectedId);
        }
      }

      resolve();
    }));
  },

  isDataSetRestricted (dataType, elementType, restrictions) {
    const appliedRestrictions = JSON.parse(restrictions).basic ?? {};
    const datasetRestrictions = this.getPermissionsSet(dataType, elementType, true);

    return Object.keys(datasetRestrictions).every(rest => datasetRestrictions[rest] === appliedRestrictions[rest]);
  },

  getElementTypeIcon (type) {
    switch (type) {
      case 'image':
        return 'thumbnail---circle';
      case 'text':
        return 'text-content---circle';
      default:
        return 'star---circle';
    }
  },

  getElement (id) {
    const element = DesignFacade.get(id) || {};
    const type = element.type || 'element';

    return {
      id,
      name: element.name || `${type} ${id.split('_')[1]}`,
      type,
      icon: this.getElementTypeIcon(type)
    };
  },

  toggleOtherRestricted (title, element) {
    const outlineColor = '#F2F4F8';

    title.parentNode.classList.toggle('highlighted');
    if (element) {
      element.style.outline = element.style.outline
        ? ''
        : `3px solid ${outlineColor}`;
    }
  }
}), ScrollableMixin);
